<script>
import navbarFilter from './navbar-filter.vue'
import navbarMenu from './navbar-menu.vue'

export default {
    components: {navbarFilter, navbarMenu},
    props: {
        favMode: {type: Boolean, default: false},
        locations: {type: Array, required: true},
        languages: {type: Array, required: true},
        streams: {type: Array, required: true},
        filter: {type: Object, required: true},
        menuItems: {type: Array, required: true}, /*
            * sample menu item:
            * {
            *   label: 'Foobar'
            *   items: [
            *      {
            *       label: 'Foo',
            *       fn: foobarAction
            *      },
            *   ]
            * }
            */
        toolButtons: {type: Array, required: true}, /*
            * sample button:
            *      {
            *       label: 'Favoriten'
            *       icon: 'fas fa-bookmark',
            *       fn: foobarAction
            *      },
            */
    },
    data() {
        return {
            search: this.filter.search,
            togglerCollapsed: true,
            tButtons: [...this.toolButtons],
        }
    },
    created() {
        if (this.favMode)
            this.tButtons.pop()  // delete favorite Button
    },
    methods: {
        onSearchInput() {
            if (this.search === '') this.$emit('delete-search')
        },
    },
}
</script>

<template>
<nav class="c-talk-navbar navbar navbar-expand-lg justify-content-between bg-info px-3">
  <button class="navbar-toggler p-1 btn navbar-btn btn-sm btn-secondary mb-1" type="button" @click.prevent="togglerCollapsed=!togglerCollapsed" >
    <i class="fas fa-bars text-white"></i>
  </button>

      <button v-for="(btn, index) in tButtons" :key="index" class="btn btn-sm navbar-btn btn-secondary me-1 mb-1"
      @click.prevent="btn.fn">
          <i :class="btn.icon"></i>
      </button>

  <div class="navbar-collapse" :class="{collapse: togglerCollapsed}" id="navbarNavDropdown">
    <ul class="navbar-nav gap-1">

        <navbar-filter v-if="locations.length" 
         label="Bühne" :filterValues="locations" :activeFilterValues="filter.location"
         @toggle-filter="$emit('toggle-location', $event)" />

        <navbar-filter v-if="streams.length"
         label="Topic" :filterValues="streams" :activeFilterValues="filter.streams"
         @toggle-filter="$emit('toggle-stream', $event)" />

        <navbar-filter v-if="languages.length"
         label="Sprache" :filterValues="languages" :activeFilterValues="filter.language"
         @toggle-filter="$emit('toggle-language', $event)" />

        <navbar-menu v-for="(menu, index) in menuItems" :key="index" :label="menu.label" :items="menu.items" />
    </ul>
  </div>
  <div :class="{'w-100': !togglerCollapsed}">
    <form class="ml-auto form-inline">
        <div class="d-flex flex-nowrap w-100">
        <input class="form-control input-sm" type="search" placeholder="Quick Search" v-model="search"
         v-on:keyup.enter="$emit('search', search)" @input="onSearchInput()">
        <button class="btn btn-sm btn-secondary" @click.prevent="$emit('search', search)">
            <span class="fa fa-search"></span>
        </button>
        </div>
    </form>
  </div>
</nav>
</template>

<style scoped>

@media screen and (min-width: 960px) {
    .c-w-search { width: initial; }
}
</style>